import { error99, Grupo, RetAPI } from '../../Utils/Types'
import { Api } from '../../Utils/api'
import { v4 as uuid } from 'uuid'
import { encode as base64_encode } from 'base-64'

export const GrupoService = {

    GetAttributes: async (id?: string): Promise<RetAPI> => {

        const resp = await Api('Grupo/attributes', 'get', { id })
        const attributes: Grupo = {
            id: 0,
            description: '',
            id_user_insert: 0,
            id_user_last_update: 0,
            id_user_exclusao: 0,
            dt_cadastro: '',
            dt_last_update: '',
            dh_exclusao: '',
            name_user_insert: '',
            name_user_last_update: '',
            name_user_delete: ''
        }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: attributes
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                if (resp.data.grupo) {

                    attributes.id = resp.data.grupo.id
                    attributes.description = resp.data.grupo.descricao

                    attributes.id_user_insert = resp.data.grupo.id_user_insert
                    attributes.id_user_last_update = resp.data.grupo.id_user_last_update
                    attributes.id_user_exclusao = resp.data.grupo.id_user_exclusao

                    attributes.dt_cadastro = resp.data.grupo.dt_cadastro
                    attributes.dt_last_update = resp.data.grupo.dt_last_update
                    attributes.dh_exclusao = resp.data.grupo.dh_exclusao

                    attributes.name_user_insert = resp.data.grupo.name_user_insert
                    attributes.name_user_last_update = resp.data.grupo.name_user_last_update
                    attributes.name_user_delete = resp.data.grupo.name_user_delete

                }
            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: attributes
            }
        }

        return {
            error: false,
            data: attributes
        }

    },

    Save: async (grupo: Grupo): Promise<RetAPI> => {

        let id = ''

        if (grupo.id) {
            id = grupo.id.toString()
        }

        const resp = await Api('Grupo/save', 'post', {

            descricao: grupo.description, id
        })


        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    field: resp.data.field
                }
            }

            return {
                error: false,
                msg: 'Dados do grupo gravados com sucesso',
                id: resp.data.grupo.id,
                data: resp.data,
                dt_cadastro: resp.data.grupo.dt_cadastro,
                dt_last_update: resp.data.grupo.dt_last_update,
                name_user_insert: resp.data.grupo.name_user_insert,
                name_user_last_update: resp.data.grupo.name_user_last_update
            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

    },

    Delete: async (idExcluir: number, motivo: string, senha: string): Promise<RetAPI> => {

        const random = uuid()

        senha = base64_encode(senha + '-' + random)

        const resp = await Api(`Grupo/delete?id=${idExcluir}&motivo=${motivo}&senha=${senha}`, 'delete')

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || ''
            } 
        }

        return {
            error: false,
            msg: '',
        }


    },

    Filter: async (field: string, filter_type: string, filter: string, id?: string): Promise<RetAPI> => {

        const resp = await Api('Grupo/filter', 'get', { field, filter_type, filter, id })
        const grupos: Grupo[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: grupos
                }
            }

            if (resp.data.error && resp.data.error === '0') {
                resp.data.grupos.map((item: any) => {
                    return grupos.push({

                        id: item.id,
                        description: item.descricao,

                        id_user_insert: item.id_user_insert,
                        id_user_last_update: item.id_user_last_update,
                        id_user_exclusao: item.id_user_exclusao,
                        dt_cadastro: item.dt_cadastro,
                        dt_last_update: item.dt_last_update,
                        dh_exclusao: item.dh_exclusao,
                        name_user_insert: item.name_user_insert,
                        name_user_last_update: item.name_user_last_update,
                        name_user_delete: item.name_user_delete
                    })
                })
            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: grupos
            }
        }

        return {
            error: false,
            data: grupos
        }

    },

    Relatorio: async (datai: string, dataf: string, descricao?: string, mostrar_excluidas?: string): Promise<RetAPI> => {

        const resp = await Api('Grupo/Report/relatorio', 'get', { datai, dataf, descricao, mostrar_excluidas })
        const grupo: any[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: grupo
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                resp.data.grupos.map((item: any) => {
                    return grupo.push({

                        id: item.id,
                        id_user_exclusao: item.id_user_exclusao,
                        dh_exclusao: item.dh_exclusao,
                        motivo_exclusao: item.motivo_exclusao,
                        name_user_delete: item.name_user_delete,
                        descricao: item.descricao,

                    })
                })
            } 

        }else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: grupo
            }
        }

        return {
            error: false,
            data: grupo,
        }
    }
}
